import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class FullPrice extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'fullprice',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
			data: null,
			loading: true,
		};
		this.inputRefs = [];
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	resetRefs() {
		this.inputRefs = [];
	}
	handleKeyDown = (rowIndex, colIndex, e) => {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (e.key === "Enter") {
			e.preventDefault();
			if (colIndex + 1 < colCount) {
				//find first next active input
				if (!row[colIndex + 1]) {
					this.handleKeyDown(rowIndex, colIndex + 1, e);
				}
				else {
					row[colIndex + 1]?.focus();
					if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
				}
			} else if (rowIndex + 1 < rowCount) {
				if (!this.inputRefs[rowIndex + 1][0]) {
					this.handleKeyDown(rowIndex + 1, 1, e);
				}
				else {
					this.inputRefs[rowIndex + 1][0]?.focus();
					if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
				}
			}
		}

		if (e.key === "ArrowDown") {
			e.preventDefault();
			e.preventDefault();
			if (rowIndex + 1 < rowCount) {
				this.inputRefs[rowIndex + 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
			}
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			if (rowIndex - 1 >= 0) {
				this.inputRefs[rowIndex - 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
			}
		}
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.httpPost("api/v1/fullprice/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;

					this.state.loading = false;
					this.updateFormula();

					if (!this.isEmpty(this.state.highlightedStuffs)) {
						var highlightedRowTimer = setInterval(() => {
							clearInterval(highlightedRowTimer);
							var t = document.getElementById('highlightedStuffs_' + this.state.highlightedStuffs[0]);
							if (t) {
								t.scrollIntoView({
									behavior: 'smooth',
									block: 'start',
									inline: 'nearest',
								});
							}
						}, 500);
					}

				}
				else {
					//this.showErorrMessage(data.message);
					this.setState({
						data: data,
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

		this.httpPost("api/v1/fullprice/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			number: this.state.data.record.number,
			factorId: this.state.data.record.factorId,
			date: this.convertMomentToDb(this.state.data.record.date),
			description: this.state.data.record.description,
			items: this.state.data.record.items,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("بارنامه با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	removeRow(id) {
		this.resetRefs();
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.updateFormula();
	}
	upIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii - 1;
			this.state.data.record.items[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii + 1;
			this.state.data.record.items[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	async setBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].id === id) {
				this.state.data.record.items[i][field] = value;
			}
		}
		this.updateFormula();
	}
	doEnterAfterSelect(rowIndex, colIndex) {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (colIndex + 1 < colCount) {
			//find first next active input
			if (!row[colIndex + 1]) {
				this.doEnterAfterSelect(rowIndex, colIndex + 1);
			}
			else {
				row[colIndex + 1]?.focus();
				if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
			}
		} else if (rowIndex + 1 < rowCount) {
			if (!this.inputRefs[rowIndex + 1][0]) {
				this.doEnterAfterSelect(rowIndex + 1, 1);
			}
			else {
				this.inputRefs[rowIndex + 1][0]?.focus();
				if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
			}
		}
	}
	updateFormula() {
		this.state.data.record.items.forEach(f => {
			if (f.otherCost === '') f.otherCost = 0;
			f.finalPrice = this.FixedPointNumber((f.total + f.serviceCost + f.wage + f.billOfLadingCost + f.customsClearanceCost + f.insuranceCost + f.otherCost) / f.count, 0);
		});
		this.setState({ date: this.state.data });
	}
	setFactor(e) {
		if (e === null) {
			this.state.data.record.factorId = null;
			this.state.data.record.factorNumber = '';
			this.state.data.record.items = [];
			this.updateFormula();
		}
		else {
			this.state.data.record.factorId = e.value;
			this.state.data.record.factorNumber = e.label;
			this.state.data.record.items = [];

			this.httpPost('api/v1/fullprice/search/factor', {
				factorId: this.state.data.record.factorId,
			}).then((data) => {
				if (data.status === -1) window.location.href = '/login';
				if (data.status === 1) {
					this.state.loading = false;
					this.state.data.record.items = data.records;
					this.updateFormula();
				} else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false,
					});
				}
			});

		}
		this.setState({ data: this.state.data });
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	renderBody() {
		var trs = [];
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach((item, index) => {
			var tds = [];
			let refColumnIndex = 0;

			tds.push(<td>
				<span className="inGridRowNumber">{(index + 1)}</span>
				{<div style={{ "font-size": "9pt", "color": "silver" }}>
					{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
					{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
				</div>}
			</td>);

			tds.push(<td>{item.stuffName}</td>);
			tds.push(<td>{item.count}</td>);
			tds.push(<td>{item.unitName}</td>);

			if (this.state.data.global.company.stuffSubUnitEnable === 2) {
				tds.push(<td>{item.modulusCount}</td>);
				tds.push(<td>{item.modulusUnitName}</td>)
			}

			tds.push(<td>{this.money(item.total)}</td>);
			tds.push(<td>{this.money(item.wage)}</td>);
			tds.push(<td>{this.money(item.billOfLadingCost)}</td>);
			tds.push(<td>{this.money(item.customsClearanceCost)}</td>);
			tds.push(<td>{this.money(item.insuranceCost)}</td>);
			tds.push(<td>{this.money(item.serviceCost)}</td>); 

			let _refColumnIndexC1 = refColumnIndex;
			tds.push(<td>
				<NumberFormat
					value={item.otherCost}
					onChange={(e) => this.setBodyValue(item.id, 'otherCost', parseInt(e.target.value.replace(/,/g, '')))}
					thousandSeparator={true}
					prefix={''}
					className="form-input text-center ltr"
					getInputRef={(el) => {
						if (!this.inputRefs[index]) this.inputRefs[index] = [];
						this.inputRefs[index][_refColumnIndexC1] = el;
					}}
					onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC1, e)}
				/>
			</td>);
			refColumnIndex++;

			tds.push(<td>{this.money(item.finalPrice)}</td>);

			tds.push(<td>
				<span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
			</td>);

			trs.push(<tr key={item.id}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">بهای تمام شده</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">

								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">فاکتور خرید<span className="red">*</span></label>
										<SelectAsync
											value={
												(!this.isNull(this.state.data.record.factorId) && this.state.data.record.factorId !== this.getDefaultGuid())
													? [
														{
															value: this.state.data.record.factorId,
															label: this.state.data.record.factorNumber,
														},
													]
													: null
											}
											isMulti={false}
											placeholder="انتخاب فاکتور خرید"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadFactorsOptions(inputValue, callback, [1, 6], 0, this.state.orderingId)}
											onChange={e => this.setFactor(e)}
										/>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
										<DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">شماره</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />

									</div>
								</div>
							</div>

							<div className="row">
								<div className={"col-lg-12"}>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td style={{ minWidth: "140px" }}>آیتم</td>
												<td style={{ "width": "70px" }}>
													<span>تعداد/مقدار</span>
												</td>
												<td>واحد اصلی</td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "70px" }}>
													<span>تعداد/مقدار<br />فرعی</span>
												</td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												<th style={{ width: '90px' }}><span>خرید</span></th>
												<th style={{ width: '90px' }}><span>کارمزد</span></th>
												<th style={{ width: '90px' }}><span>بارنامه</span></th>
												<th style={{ width: '90px' }}><span>ترخیص</span></th>
												<th style={{ width: '90px' }}><span>بیمه</span></th>
												<th style={{ width: '90px' }}><span>خدمات</span></th>
												<th style={{ width: '90px' }}><span>سایرهزینه ها</span></th>
												<th style={{ width: '90px' }}><span>فی نهایی</span></th>
												<td style={{ "width": "35px" }}>عملیات</td>
											</tr>
										</thead>
										{this.renderBody()}
									</table>
								</div>
							</div>

						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							&nbsp;
							{this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف</a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}